import classNames from 'classnames/bind';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import styles from './SelectSpecs.module.scss';

import actions from '@/actions';
import AddTakeoffModal from '@/components/modals/AddTakeoff';
import Select from '@/components/ui/kit/Select';
import ModalWrapper from '@/components/ui/ModalWrapper';
import { ModalService as modal } from '@/libs/Modal';
import { NotifierService as notifier } from '@/libs/Notifier';

const cx = classNames.bind(styles);

const Modal = () => {
  const dispatch = useDispatch();
  const [specs, setSpecs] = useState({
    protocol: '',
    firmware: '',
    frame: '',
  });

  const handleChange = (e) => {
    const nextSpecs = { ...specs };

    switch (e.target.name) {
      case 'protocol':
        nextSpecs.protocol = e.target.value;
        nextSpecs.firmware = '';
        nextSpecs.frame = '';
        break;

      case 'firmware':
        nextSpecs.firmware = e.target.value;
        nextSpecs.frame = '';
        break;

      case 'frame':
        nextSpecs.frame = e.target.value;
        break;

      default:
        break;
    }

    setSpecs(nextSpecs);
  };

  const doOK = () => {
    if (!specs.protocol) {
      notifier.error('Please select a protocol.');
      return;
    }

    if (specs.protocol === 'mavlink') {
      if (!specs.firmware) {
        notifier.error('Please select a firmware.');
        return;
      }
      if (!specs.frame) {
        notifier.error('Please select a frame.');
        return;
      }
    }

    dispatch(actions.mission.setSpecs(specs));

    modal.hide();
    modal.show(AddTakeoffModal);
  };

  return (
    <ModalWrapper disableEscape className={cx('container')}>
      <div className={cx('message')}>Select the specifications first.</div>
      <div className={cx('body')}>
        <Select name="protocol" value={specs.protocol} onChange={handleChange}>
          <option value="dji">DJI</option>
          <option value="mavlink">MavLink</option>
        </Select>
        <Select name="firmware" value={specs.firmware} onChange={handleChange} disabled={specs.protocol !== 'mavlink'}>
          <option value="ardupilot">ArduPilot</option>
          <option value="px4">PX4</option>
        </Select>
        <Select name="frame" value={specs.frame} onChange={handleChange} disabled={specs.firmware === ''}>
          <option value="boat">Boat</option>
          <option value="copter">Copter</option>
          <option value="fixedwing">Plane (Fixed-wing)</option>
          <option value="vtol">Plane (VTOL)</option>
          <option value="rover">Rover</option>
        </Select>
      </div>
      <button type="button" className={cx(['button', 'accent'])} onClick={doOK}>
        OK
      </button>
    </ModalWrapper>
  );
};

export default Modal;
